import * as React from 'react';
import { Typography, Container } from '@mui/material';
import { motion } from 'framer-motion';
import { SectionContainer } from '@/components/LandingPage/Components/styles';
import { NextSeo } from 'next-seo';

import Header from '../components/LandingPage/Header';
import Footer from '../components/LandingPage/Footer';
import ScrollToTop from '../components/LandingPage/Components/ScrollToTop';

const privacyPolicySections = [
  {
    title: "Introduction",
    content: () => (
      <>
        Greetings from Wave Horizons LTD. Wave Horizons LTD (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) is the proprietor of the <a href="https://www.scriptu.io">https://www.scriptu.io</a> website (&quot;the Service&quot;). This Privacy Policy details the nature of data collection, protection, and disclosure practices that apply during your interaction with <a href="https://www.scriptu.io">https://www.scriptu.io</a>. Engaging with our Service signifies your consent to the data practices described in this policy. This Privacy Policy, alongside our Terms and Conditions, forms the entirety of your contract with us.
      </>
    )
  },
  {
    title: "Definitions",
    content: () => (
      <>
        <strong>SERVICE</strong> refers to the <a href="https://www.scriptu.io">https://www.scriptu.io</a> website operated by Wave Horizons LTD. <br />
        <strong>PERSONAL DATA</strong> means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).<br />
        <strong>USAGE DATA</strong> is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).<br />
        <strong>COOKIES</strong> are small files stored on your device (computer or mobile device).<br />
        <strong>DATA CONTROLLER</strong> means the natural or legal person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed.<br />
        <strong>DATA PROCESSORS (OR SERVICE PROVIDERS)</strong> means any natural or legal person who processes the data on behalf of the Data Controller.<br />
        <strong>DATA SUBJECT</strong> is any living individual who is the subject of Personal Data.<br />
        <strong>THE USER</strong> is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.
      </>
    )
  },
  {
    title: "Collecting and Utilizing Information",
    content: "Our Service is designed to collect various types of information to enhance your user experience and improve the Service we offer."
  },
  {
    title: "Data Types We Collect",
    content: () => (
      <>
        <strong>Personal Information</strong><br />
        To utilize certain aspects of our Service, you may be prompted to provide personal information that can identify or contact you. This may include, but is not limited to:<br />
        - Email addresses<br />
        - Cookies and Usage Data<br /><br />
        <strong>Usage Information</strong><br />
        Our servers may also collect information on how the Service is accessed and used. This data may encompass details like your {"device's"} internet protocol (IP) address, browser type, browser version, our Service pages that you visit, time and date of your visit, and other diagnostic data.<br /><br />
        <strong>Tracking & Cookies</strong><br />
        We employ cookies and similar tracking tools to monitor activity on our Service and store certain information. You can control these through your browser settings, though some Service features may not function properly without them.
      </>
    )
  },
  {
    title: "Purposes of Data Use",
    content: "Wave Horizons LTD processes collected data to facilitate and maintain the Service, inform users of modifications to the Service, enable interactive Service features at your discretion, provide customer care and support, analyze valuable insights to optimize the Service, monitor Service utilization, and address and troubleshoot technical concerns."
  },
  {
    title: "Data Retention",
    content: "Your Personal Data is kept only as long as necessary for the purposes outlined in this Privacy Policy. Usage Data may be stored for shorter durations, except when needed to ensure security, improve functionality, or comply with legal obligations."
  },
  {
    title: "Data Transfer",
    content: "Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your jurisdiction where data protection laws may differ than those from your jurisdiction."
  },
  {
    title: "Data Disclosure",
    content: "We may disclose your information as outlined in this Privacy Policy, including for law enforcement, during business transactions, or to our subsidiaries and service providers for the purposes mentioned."
  },
  {
    title: "Data Security",
    content: "While we strive for the secure transmission and storage of your data, remember that no method is infallible. We are committed to protecting your Personal Data but cannot guarantee its absolute security."
  },
  {
    title: "Your Rights",
    content: "Residents of the European Union (EU) and European Economic Area (EEA) have certain rights under the General Data Protection Regulation (GDPR) regarding their Personal Data. These include rights to access, correct, or delete your data, among others. For inquiries or requests, please contact us at contact@scriptu.io."
  },
  {
    title: "Third-Party Services",
    content: "To enhance our Service, we may use various third-party services. These entities may access your Personal Data solely to perform tasks on our behalf and are obligated not to disclose or use it for other purposes."
  },
  {
    title: "Analytics",
    content: "Our Service may use third-party providers to monitor and analyze web traffic and usage."
  },
  {
    title: "Amendments to This Policy",
    content: "We reserve the right to update our Privacy Policy periodically. Any changes will be communicated by posting the new policy on this page."
  },
  {
    title: "Contacting Us",
    content: "For any questions regarding this Privacy Policy, please reach out to us via email at contact@scriptu.io."
  }
];


export default function Privacy() {

  return (
    <>
    <NextSeo
                title="Scriptu Privacy Policy"
                canonical="https://www.scriptu.io/privacy" // Add your canonical URL here
                openGraph={{
                    url: "https://www.scriptu.io/privacy", // It's also good to set the URL in openGraph
                    title: "Scriptu Privacy Policy",
                    images: [
                        {
                            url: "/logo-promo.png",
                            width: 2000,
                            height: 520,
                            alt: "Scriptu Logo",
                        },
                    ],
                    site_name: "Scriptu",
                }}
                twitter={{
                    handle: '@handle',
                    site: '@site',
                    cardType: 'summary_large_image',
                }}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: '/favicon.png',
                    },
                    {
                        rel: 'apple-touch-icon',
                        href: '/favicon.png',
                        sizes: '128x128',
                    },
                ]}
            />
      <div id="back-to-top-anchor"></div>
      <div style={{
        background: 'black',
        backgroundImage: 'url(/bg.jpg)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}>
        <div id="back-to-top-anchor"></div>
        <Header />
      </div>
      <Container maxWidth="lg" sx={{ mt: 3, mb: 6 }}>
        <SectionContainer>
          <Typography variant="h3" sx={{ fontSize: '44px', color: '#000135', fontWeight: 700, lineHeight: 1.13, letterSpacing: '-1.76px', mt: 5, mb: 10 }}>
            Privacy Policy
          </Typography>

          {privacyPolicySections.map((section, index) => (
            <div key={index}>
              <Typography variant="h6" gutterBottom sx={{ fontSize: '24px', color: '#000135', fontWeight: 700, lineHeight: 1.13, letterSpacing: '-1.76px', mt: 3, textTransform: 'capitalize', textAlign: 'left' }}>
                {index + 1}. {section.title}
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ fontSize: '16px', color: '#000135', fontWeight: 400, textAlign: 'left', mb: 2 }}>
                {typeof section.content === 'function' ? section.content() : section.content}
              </Typography>
            </div>
          ))}
        </SectionContainer>

      </Container>
      <Footer />
      <ScrollToTop />
    </>
  );
}
